import { constants } from '@/core/constants'

const urlHelpers = {
  // TODO: Refactor to use "import { getAbsoluteURL } from '@/utils/url'" instead
  getAbsoluteURL(url) {
    if (url.startsWith('http')) {
      return url
    }
    if (!url.startsWith('/')) {
      url = `/${url}`
    }
    return `${constants.HOST_URL}${url}`
  },
}

export default urlHelpers
